export default {
	NUMBER_19: 'number_19',
	NUMBER_19_WITH_NEGATIVE: 'number_19_neg',
	NUMBER_POSITIVE_AMOUNT: 'number_positive_amount',
	NUMBER_POSITIVE_AMOUNT_3: 'number_positive_amount_3',
	NUMBER_DECIMAL: 'number_decimal',
	INTEGER_POSITIVE_AMOUNT: 'integer_positive_amount',
	PHONE: 'phone'
}